// src/pages/UserProfile.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import UserAvatar from "../components/UserAvatar";
import { getServiceAvailablePlaces, hasUpcomingCreneau } from "../utils/serviceUtils";

const UserProfile = () => {
  const { id } = useParams(); // id du créateur
  const [user, setUser] = useState(null);
  const [services, setServices] = useState([]);
  const [avis, setAvis] = useState([]);
  const [newAvis, setNewAvis] = useState("");
  const [newServiceReceived, setNewServiceReceived] = useState("");
  const [avisMessage, setAvisMessage] = useState("");
  const [showAvisForm, setShowAvisForm] = useState(false);
  //const [reservations, setReservations] = useState([]);
  const [activeTab, setActiveTab] = useState("apropos");
  const navigate = useNavigate();

 
const getDomaineStyle = () => {
  return {
    backgroundColor: "var(--accent-primary-soft)",
    color: "var(--accent-primary)",
    border: "1px solid var(--accent-primary)",
  };
};

  const getEmbedVideoUrl = (url) => {
    if (!url) return null;

    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      const videoId =
        url.includes("youtu.be")
          ? url.split("/").pop()
          : new URL(url).searchParams.get("v");

      return `https://www.youtube.com/embed/${videoId}`;
    }

    if (url.includes("vimeo.com")) {
      const videoId = url.split("/").pop();
      return `https://player.vimeo.com/video/${videoId}`;
    }

    return url;
  };

  useEffect(() => {
    api.get(`/api/users/${id}`).then((res) => setUser(res.data));
    api.get(`/api/services/serv/user/${id}`).then(async (res) => {
      const raw = res.data || [];
      const withRemaining = await Promise.all(
        raw.map(async (s) => {
          try {
            const countRes = await api.get(`/api/reservations/count/${s._id}`);
            const backendRemaining = Number(s?.placesRestantes);
            const totalPlaces = Number.isFinite(backendRemaining) && backendRemaining >= 0
              ? backendRemaining
              : (getServiceAvailablePlaces(s) || 1);
            const placesRestantes = Number.isFinite(backendRemaining) && backendRemaining >= 0
              ? backendRemaining
              : Math.max(totalPlaces - (countRes.data.count || 0), 0);
            return { ...s, placesRestantes };
          } catch {
            return { ...s, placesRestantes: 1 };
          }
        })
      );

      const isServiceActive = (s) =>
        s?.isActive !== false &&
        s?.active !== false &&
        s?.desactive !== true &&
        s?.status !== "inactive";

      setServices(withRemaining.filter((s) => isServiceActive(s)));
    });
    //api.get(`/api/reservations/user/${id}`).then((res) => setReservations(res.data));
  }, [id]);

  useEffect(() => {
    api.get(`/api/avis/user/${id}`).then((res) => setAvis(res.data));
  }, [id]);

  const handleSubmitAvis = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      setAvisMessage("Veuillez vous connecter pour poster un témoignage.");
      return;
    }

    if (!newAvis.trim()) {
      setAvisMessage("Le témoignage ne peut pas être vide.");
      return;
    }

    try {
      const storedUser = JSON.parse(localStorage.getItem("user") || "null");
      const optimisticAvis = {
        _id: `local-${Date.now()}`,
        commentaire: newAvis.trim(),
        serviceRecu: newServiceReceived.trim(),
        auteur: {
          _id: storedUser?.id || storedUser?._id || "",
          prenom: storedUser?.prenom || "",
          name: storedUser?.name || "",
          photo: storedUser?.photo || "",
        },
        createdAt: new Date().toISOString(),
      };

      setAvis((prev) => [optimisticAvis, ...prev]);

      const res = await api.post(
        `/api/avis/user/${id}`,
        {
          commentaire: newAvis.trim(),
          serviceRecu: newServiceReceived.trim(),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const serverAvis = res.data?.avis || res.data;
      const normalizedAvis = serverAvis && typeof serverAvis === "object"
        ? {
            ...optimisticAvis,
            ...serverAvis,
            commentaire: serverAvis.commentaire || newAvis.trim(),
            serviceRecu: serverAvis.serviceRecu || serverAvis.serviceReceived || serverAvis.service?.titre || newServiceReceived.trim(),
            auteur: serverAvis.auteur || optimisticAvis.auteur,
          }
        : optimisticAvis;

      setAvis((prev) => [normalizedAvis, ...prev.filter((item) => item._id !== optimisticAvis._id)]);

      if (res.data?.user?.credits !== undefined) {
        const storedUser = JSON.parse(localStorage.getItem("user") || "null");
        if (storedUser) {
          const updatedUser = { ...storedUser, credits: res.data.user.credits };
          localStorage.setItem("user", JSON.stringify(updatedUser));
          window.dispatchEvent(new CustomEvent("creditsUpdated", { detail: updatedUser }));
        }
      }

      setNewAvis("");
      setNewServiceReceived("");
      setShowAvisForm(false);
      setAvisMessage(
        res.data?.user?.credits !== undefined
          ? "Témoignage posté avec succès. 5 crédits ont été ajoutés à votre compte."
          : "Témoignage posté avec succès."
      );
    } catch (err) {
      setAvisMessage(err.response?.data?.msg || "Impossible de poster le témoignage.");
    }
  };

  if (!user) return <p className="text-center py-10">Chargement...</p>;

  const contactEmail = user.emailDeContact || user.mailDeContact || user.contactEmail || null;

  // Calcul note moyenne
 // const avisAvecNote = avis.filter(a => {
  //  const n = typeof a.note === 'string' ? parseFloat(a.note) : a.note;
   // return typeof n === 'number' && !isNaN(n) && n >= 1 && n <= 5;
 // });

//const noteMoyenne = avisAvecNote.length > 0
   // ? avisAvecNote.map(a => typeof a.note === 'string' ? parseFloat(a.note) : a.note)
   //     .reduce((acc, n) => acc + n, 0) / avisAvecNote.length
//    : null;

 // const noteAffichee = noteMoyenne ? noteMoyenne.toFixed(1) : "Non noté";
  //const nombreAvis = avis.length;


  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
      <Header />
      <main className="max-w-6xl mx-auto px-6 py-8">
        {/* Retour */}
        <button
          onClick={() => navigate(-1)}
          className="link-fuchsia hover:underline mb-6 flex items-center gap-1 text-lg transition-colors"
        >
          ← Retour
        </button>

        {/* Profil */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 flex flex-col md:flex-row items-start gap-8">
          {/* Photo */}
          <UserAvatar
            photo={user.photo}
            name={user.name}
            prenom={user.prenom}
            alt={`${user.prenom || ""} ${user.name || ""}`.trim()}
            className="w-32 h-32 text-4xl"
          />

          {/* Infos */}
          <div className="flex-1">
            <h1 className="text-3xl font-bold text-gray-800"> {user.prenom} {user.name} </h1>
            {user.metier && <p className="text-lg text-gray-600 mt-1">{user.metier}</p>}
            

    {Array.isArray(user.domaine) && (
  <div className="flex flex-wrap gap-2 mt-2 max-w-full overflow-hidden">
    {user.domaine.map((domaine, index) => (
      <span
        key={index}
        style={getDomaineStyle(domaine)}
        className="px-3 py-1 rounded-full text-sm font-medium"
      >
        {domaine}
      </span>
    ))}
  </div>
)}


 <div className="flex flex-wrap justify-center md:justify-start items-center gap-6 mt-4 text-sm text-gray-600">
              {user.role === "createur" && (
                <>
                  <div className="flex items-center gap-1">🌍 <span>{user.langues?.join(", ") || "Non renseigné"}</span></div>
                  <div className="flex items-center gap-1">📍 <span>{user.lieuPrestation || "Non renseigné"}</span></div>
                </>
              )}
            </div>

         {/*    {nombreAvis > 0 && (
              <div className="flex items-center gap-1 mt-3">
                <span className="text-yellow-500">⭐</span>
                <span className="text-sm text-gray-600">{noteAffichee} ({nombreAvis} avis)</span>
              </div>
            )}

             */} 

              

          </div>

          {/* Bouton contacter */}
          <button
            onClick={() => {
              if (contactEmail) {
                window.location.href = `mailto:${contactEmail}`;
              }
            }}
            className="mt-4 md:mt-0 btn-primary px-6 py-3 font-medium"
          >
            ✉️ Contacter
          </button>
        </div>

        {/* Onglets */}
        <div className="flex flex-wrap gap-6 border-b mb-8">
          <div className="flex gap-6 border-b mb-6">
          <button
            onClick={() => setActiveTab("apropos")}
            className={`tab-accent ${activeTab === "apropos" ? "tab-accent-active" : "tab-accent-idle"}`}
          >
            À propos de moi
          </button>
            {user.role !== "particulier" && (

          <button
            onClick={() => setActiveTab("services")}
            className={`tab-accent ${activeTab === "services" ? "tab-accent-active" : "tab-accent-idle"}`}
          >
            Services proposés
          </button>
            )}

        {}
          <button
            onClick={() => setActiveTab("avis")}
            className={`tab-accent ${activeTab === "avis" ? "tab-accent-active" : "tab-accent-idle"}`}
          >
            Témoignages
          </button>
        </div>

        </div>

        {/* Contenu des onglets */}
{activeTab === "apropos" && (

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  
  {/* Bloc gauche : service OU message */}
  <div className="md:col-span-2 bg-white p-6 rounded-lg shadow">
    
   {/* Vidéo : afficher uniquement si présente */}
      {user.video && (
        <div className="w-full h-64 rounded-lg overflow-hidden mb-4">
          {user.video.includes("youtube") || user.video.includes("vimeo") ? (
            <iframe
              src={getEmbedVideoUrl(user.video)}
              title="Vidéo de présentation"
              className="w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video controls className="w-full h-full object-cover">
              <source src={user.video} type="video/mp4" />
              Votre navigateur ne supporte pas la lecture vidéo.
            </video>
          )}
        </div>
      )}
      {/* Description */}
      {user.description && (
        <p className="text-gray-700 mb-4 whitespace-pre-line">{user.description}</p>
      )}

  </div>

  {/* Bloc droite : LIENS (toujours au même endroit) */}
  <div className="bg-white p-6 rounded-lg shadow h-fit">
    <h3 className="text-xl font-semibold mb-4 text-[var(--accent-primary)]">Liens</h3>

    {(user.siteWeb || user.instagram || user.linkedin) ? (
      <ul className="space-y-2 text-gray-800">
        {user.siteWeb && (
          <li>
           <strong>Site web :</strong>{" "}
            <a
              href={user.siteWeb.startsWith("http") ? user.siteWeb : `https://${user.siteWeb}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-accent underline break-all"
            >
              {user.siteWeb}
            </a>
          </li>
        )}

        {user.instagram && (
          <li>
         <strong>Instagram :</strong>{" "}
            <a
              href={user.instagram.startsWith("http") ? user.instagram : `https://${user.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-accent underline break-all"
            >

{user.instagram}      
      </a>
          </li>
        )}

        {user.linkedin && (
          <li>

     <strong>LinkedIn :</strong>{" "}
            <a
              href={user.linkedin.startsWith("http") ? user.linkedin : `https://${user.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-accent underline break-all"
            >
              {user.linkedin}
            </a>
          </li>
        )}
      </ul>
    ) : (
      <p className="text-gray-500 italic">
        Aucun lien renseigné.
      </p>
    )}
  </div>



           <div className="md:col-span-3 flex flex-col space-y-4">

  {user.valeurs && (
    <div className="bg-white p-6 rounded-xl shadow">
      <h3 className="text-xl font-semibold mb-3 text-[var(--accent-primary)]">
        Mes valeurs profondes
      </h3>
      <p className="text-gray-700 whitespace-pre-line">{user.valeurs}</p>
    </div>
  )}

  {user.role === "createur" && (
    <div className="bg-white p-6 rounded-xl shadow">
      <h3 className="mb-3 text-xl font-semibold text-[var(--accent-primary)]">
        Informations pratiques
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
        <p><strong>Langues parlées :</strong> {user.langues?.join(", ") || "Non renseigné"}</p>
        <p><strong>Type de séance :</strong> {user.typeCours || "Non renseigné"}</p>
        <p><strong>Téléphone :</strong> {user.telephone || "Non renseigné"}</p>
        <p><strong>Email de contact :</strong> {contactEmail || "Non renseigné"}</p>
        <p><strong>Nationalité :</strong> {user.nationalites || "Non renseigné"}</p>
      </div>
    </div>
  )}

</div>

              {user.role === "particulier" && (

            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="text-xl font-semibold mb-3 text-[var(--accent-primary)]">Coordonnées</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
                <p><strong>Email :</strong> {user.email || "Non renseigné"}</p>
                <p><strong>Téléphone :</strong> {user.telephone || "Non renseigné"}</p>
              
              </div>
            </div>
            )}
          </div>
        )}
   {activeTab === "services" && (
          <div>
            <h2 className="text-xl font-semibold mb-4">Services proposés</h2>
            {services.length === 0 ? (
              <p className="text-gray-500">Aucun service proposé pour l’instant.</p>
            ) : (
              <div className="grid grid-cols-3 sm:grid-cols-3 gap-6">
                {services.map((service) => {
                  const isReservable = service.placesRestantes > 0 && hasUpcomingCreneau(service);
                  const serviceActionLabel = isReservable ? "Réserver" : "Plus disponible";

              //    const avisDuService = avis.filter(a => a.service?._id === service._id);
                    

                  return (
                    <div
                      key={service._id}
                      className={`rounded-xl bg-white p-4 shadow transition ${isReservable ? "cursor-pointer hover:shadow-lg" : "cursor-default opacity-80"}`}
                      onClick={() => {
                        if (isReservable) {
                          navigate(`/service/${service._id}`);
                        }
                      }}
                    >
                      <div className="flex items-center gap-3 mb-3">
                        <div>
                          <h3 className="font-semibold text-gray-800">{service.titre || "Sans titre"}</h3>
                          
                        </div>
                      </div>
                      <div className="mt-2 flex items-center text-xs text-gray-500 gap-3">
  {/* Position */}
  <span className="flex items-center gap-1">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5 9 6.343 9 8s1.343 3 3 3z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 22s8-8.5 8-14a8 8 0 10-16 0c0 5.5 8 14 8 14z" />
    </svg>
    {service.typePrestation || "Distanciel"} - {service.lieu || "France"}
  </span>

  {/* Durée */}
  <span className="flex items-center gap-1">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z" />
    </svg>
    {service.duree || "1h30"}
  </span>

  {/* Collectif / Individuel */}
  <span className="flex items-center gap-1">
<svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    </svg>


    {service.typeCours || "Individuelle"}
  </span>
</div>

                      <div className="flex items-center justify-between mt-3">
                        <span className="font-semibold credits-fuchsia">{service.creditsProposes} crédits</span>
                        <button
                          type="button"
                          disabled={!isReservable}
                          className={`w-32 py-2 text-sm ${isReservable ? "btn-primary" : "rounded-lg border border-gray-300 bg-gray-100 text-gray-500"}`}
                        >
                          {serviceActionLabel}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      

    {/*   {activeTab === "reserves" && (
  <div>
    <h2 className="text-xl font-semibold mb-4">Services ou créations réservés</h2>
    {reservations.length === 0 ? (
      <p className="text-gray-500">Vous n'avez réservé aucun service pour l'instant.</p>
    ) : (
      <div className="space-y-4">
       {reservations.map(r => {
  const service = r.service;
  const createur = user;
  const categorie = service?.categorie || service?.categories?.[0];

  return (
    <div key={r._id} className="bg-white p-4 rounded-lg shadow flex items-center justify-between">
      <div>
        <h3 className="font-semibold">{service?.titre || "Sans titre"}</h3>
        <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
          {categorie && (
            <span
              style={{
                backgroundColor: `${getCouleurCategorie(categorie)}20`,
                color: getCouleurCategorie(categorie),
                border: `1px solid ${getCouleurCategorie(categorie)}`,
              }}
              className="px-2 py-1 rounded-full text-xs font-medium"
            >
              {categorie}
            </span>
          )}
          <span className="flex items-center gap-1">  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z" />
    </svg> {service?.duree || "Non précisé"}</span>
          <span className="flex items-center gap-1"> 
            
 

<svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    </svg>
 {service?.typeCours || "Non précisé"}</span>
          <span>avec {createur?.name} {createur?.prenom}</span>
          <span>le {new Date(r.date).toLocaleDateString('fr-FR')}</span>
        </div>
      </div>

      <div className="flex flex-col items-center gap-3">
        <span className="text-[var(--status-success)] font-semibold text-sm">
          {service?.creditsProposes || 0} crédits
        </span>
        <button
          className="px-3 py-1 badge-accent"
          onClick={() => {
            if (createur?._id) {
              navigate(`/messagerie/${createur._id}`);
            } else {
              alert("ID du créateur non disponible");
            }
          }}
        >
          Contacter
        </button>
      </div>
    </div>
  );
})}

      </div>
    )}
  </div>
)}
        {activeTab === "portefeuille" && (
       
         <div>
            <h2 className="text-xl font-semibold mb-4">Mon portefeuille</h2>
            <div className="bg-white p-6 rounded-lg shadow text-center">
              <p className="text-3xl font-bold text-[var(--accent-primary)]">{user.credits} ⚡</p>
              <p className="text-gray-600">Solde de crédits</p>
            </div>
          </div>
        )}
        */}

        {activeTab === "avis" && (
          <div>
            <div className="mb-4 flex items-center gap-3">
              <button
                type="button"
                onClick={() => setShowAvisForm((prev) => !prev)}
                className="btn-primary px-4 py-2"
              >
                Poster un témoignage
              </button>
              {avisMessage && (
                <span className="text-sm text-gray-600">{avisMessage}</span>
              )}
            </div>

            {showAvisForm && (
              <form onSubmit={handleSubmitAvis} className="bg-white p-4 rounded-xl shadow mb-4 space-y-3">
                <div>
                  <label className="block text-sm text-gray-700 mb-1">Témoignage</label>
                  <textarea
                    value={newAvis}
                    onChange={(e) => setNewAvis(e.target.value)}
                    rows={4}
                    placeholder="Partagez votre expérience avec ce créateur..."
                    className="w-full border border-gray-300 px-3 py-2 rounded"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">Service reçu</label>
                  <input
                    type="text"
                    value={newServiceReceived}
                    onChange={(e) => setNewServiceReceived(e.target.value)}
                    placeholder="Ex : Atelier d'écriture, accompagnement individuel..."
                    className="w-full border border-gray-300 px-3 py-2 rounded"
                  />
                </div>
                <p className="text-sm text-gray-500">Chaque témoignage validé donne droit à 5 crédits.</p>
                <button type="submit" className="btn-primary px-4 py-2">
                  Publier
                </button>
              </form>
            )}

            {avis.length === 0 ? (
              <p className="text-gray-500"> </p>
            ) : (
              <div className="space-y-4">
                {avis.map(a => (
                  <div key={a._id} className="bg-white p-4 rounded-xl shadow">
                    <div className="flex items-center gap-3 mb-2">
                      <UserAvatar
                        photo={a.auteur?.photo}
                        name={a.auteur?.name}
                        prenom={a.auteur?.prenom}
                        className="w-10 h-10"
                      />
                      <div className="flex-1">
                        <div className="flex justify-between items-center">
                          <div>
                          <p className="font-medium">
                              {a.auteur?.prenom} {a.auteur?.name} 
                          </p>
                        </div>
                          <span className="text-sm text-gray-400">
                            {new Date(a.createdAt).toLocaleDateString("fr-FR")}
                          </span>
                        </div>
                      </div>
                       
                     
                    </div>
                    <p className="text-gray-700">{a.commentaire}</p>
                    <p className="mt-2 text-sm italic text-gray-500">Service reçu : {a.serviceRecu || a.serviceReceived || a.service?.titre || "Non renseigné"}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default UserProfile;